<script lang="ts">
    import { onMount } from 'svelte';

    import Toast from '@/components/fifaLogin/Toast.svelte';
    import { globalToastMessage } from '@/utils/globalToast';

    let toastRef: Toast;

    onMount(() =>
        globalToastMessage.subscribe((msg) => {
            if (!msg) return;

            globalToastMessage.set(null);
            toastRef?.show(msg);
        })
    );
</script>

<Toast bind:this={toastRef} />
